import React from "react";

import { ButtonStandard, Text } from "@performyard/py-components";
import { SurveyAnswerJson } from "@performyard/service-contracts";

import ContentModal from "../../../../../../../components/Modal/Templates/ContentModal";

import { AUTHOR_SURVEY_MODALS } from "../store/model";
import { useAnswers, useModal, useSetters } from "../store/store";

const SubmitIncompleteSurveyModal = ({
	getUnansweredQuestions,
	submitResponse,
	submitting,
}: {
	getUnansweredQuestions: (answers: Record<string, SurveyAnswerJson["value"]>) => string[];
	submitResponse: ({ answers }: { answers: Record<string, SurveyAnswerJson["value"]> }) => void;
	submitting: boolean;
}) => {
	const setters = useSetters();
	const modal = useModal();
	const answers = useAnswers();

	const unansweredQuestions = getUnansweredQuestions(answers);

	return (
		<ContentModal
			isOpen={modal === AUTHOR_SURVEY_MODALS.SUBMIT_INCOMPLETE_SURVEY}
			handleClose={() => setters.setModal(null)}
			hideCloseButton={true}
			title={
				<Text size="sub-heading" weight="semi-bold">
					Submit Survey?
				</Text>
			}
			size="small"
			buttons={[
				<ButtonStandard key="cancel" type="button" onClick={() => setters.setModal(null)} size="large">
					Cancel
				</ButtonStandard>,
				<ButtonStandard
					data-testid="submit-anyways-button"
					key="submit"
					type="submit"
					color="green"
					size="large"
					disabled={submitting}
					onClick={() => {
						submitResponse({ answers });
						setters.setModal(null);
					}}
				>
					Yes, Submit
				</ButtonStandard>,
			]}
		>
			<Text size="paragraph-1" weight="semi-bold">
				<div className="text-center" data-testid="unanswered-questions-modal">
					You left {unansweredQuestions.length} question{unansweredQuestions.length === 1 ? "" : "s"} blank.
					Are you sure you wish to submit this survey?
				</div>
			</Text>
		</ContentModal>
	);
};

/**
 * Renders all the author surveys modals so we can switch open modal via the surevys store
 */
const SurveysModals = ({
	getUnansweredQuestions,
	submitResponse,
	submitting,
}: {
	getUnansweredQuestions: (answers: Record<string, SurveyAnswerJson["value"]>) => string[];
	submitResponse: ({ answers }: { answers: Record<string, SurveyAnswerJson["value"]> }) => void;
	submitting: boolean;
}) => {
	return (
		<>
			<SubmitIncompleteSurveyModal
				getUnansweredQuestions={getUnansweredQuestions}
				submitResponse={submitResponse}
				submitting={submitting}
			/>
		</>
	);
};
export default SurveysModals;
